export const compactFomat = (n: number) =>
  new Intl.NumberFormat("en-GB", {
    notation: "compact",
    compactDisplay: "short"
  }).format(n);
